import { mqtt5 } from 'aws-iot-device-sdk-v2';
import { interfaces } from 'inversify';
import { IoTBrowserClientService } from './IoTBrowserClientService';

export async function createClient(context: interfaces.Context): Promise<mqtt5.Mqtt5Client> {
    return context.container.get(IoTBrowserClientService).getClient();
}